module.exports = __webpack_public_path__ + "img/favorite.decca165.svg";